import ABCyaPhaser from '@abcya/abcya_phaser'
import gameData from '../gameData';

export default class Sky extends Phaser.GameObjects.Container
{
    constructor(scene)
    {
        super(scene);
        scene.add.existing(this);

        this.scene = scene;

        this.paused = false;
        this.tweens = [];

        this.createSky();
    }

    createSky()
    {
        this.cloud1 = ABCyaPhaser.Images.addImage(0, 0, "cloud1", this);
        this.cloud2 = ABCyaPhaser.Images.addImage(0, 0, "cloud2", this);
        this.cloud3 = ABCyaPhaser.Images.addImage(0, 0, "cloud3", this);
        this.clouds = [this.cloud1, this.cloud2, this.cloud3];
    }

    skyIntro(){
        this.clouds.forEach(cloud => { this.moveClouds(cloud); });
    };

    moveClouds(obj){
        //randomly generate scale, alpha and Y position
        obj.y = !gameData.DESKTOP ? Phaser.Math.Between(75, this.scene.mid.y*2-400) : Phaser.Math.Between(75, this.scene.mid.y*2-600);
        obj.setScale(Phaser.Math.FloatBetween(.25, 1.25));
        obj.setAlpha(Phaser.Math.FloatBetween(.3, .5));

        const randTime = Phaser.Math.Between(15000, 20000);
        let destination;

        //reset the X position of the cloud when it get to the other side. Tween across with a random time between 15-20 seconds
        if(obj.frame.name == "cloud1"){ 
            this.cloud1.x = this.scene.mid.x*2 + this.cloud1.width;
            destination = -this.scene.mid.x*2 + obj.width;
        }
        else if(obj.frame.name == "cloud2"){ 
            this.cloud2.x = -this.cloud2.width - this.cloud2.width;
            destination = this.scene.mid.x*2 + obj.width;
        }
        else if(obj.frame.name == "cloud3"){ 
            this.cloud3.x = -this.cloud3.width - this.cloud3.width;
            destination = this.scene.mid.x*2 + obj.width;
        }

        const cloudTween = ABCyaPhaser.Tweens.addTween(obj, randTime, {x:destination}, Phaser.Math.Easing.Linear, ()=>{
            this.moveClouds(obj);
        });
        this.tweens.push(cloudTween);
    };

    toggleMovement(){
        this.tweens.forEach(tween => { tween.pause(); });
    };

    stopClouds(){
        this.clouds.forEach(cloud => { this.scene.tweens.killTweensOf(cloud); });
    };

    destroySky()
    {
        this.stopClouds();
        this.removeAll(true);
        super.destroy();
    }
}